/** International Afghan mobile: 937 + 8–9 subscriber digits (11–12 digits total). */
export const LEAD_PHONE_REGEX = /^937\d{8,9}$/;
const LOCAL_PHONE_REGEX = /^07\d{8}$/;
const LOCAL_PHONE_WITHOUT_ZERO_REGEX = /^7\d{8}$/;
function toLeadPhoneInput(raw) {
    if (raw == null)
        return '';
    return String(raw).trim();
}
export function cleanLeadPhoneNumber(phoneNumber) {
    return phoneNumber
        .replace(/^\+93/, '93')
        .replace(/^0093/, '93')
        .replace(/^00/, '')
        .replace(/^0/, '')
        .replace(/[\s\-()]/g, '');
}
export function normalizeLeadPhoneNumber(raw) {
    const input = toLeadPhoneInput(raw);
    if (!input)
        return '';
    const stripped = input.replace(/[\s\-()]/g, '');
    const withoutCountryPrefix = stripped
        .replace(/^\+93/, '')
        .replace(/^0093/, '')
        .replace(/^00/, '');
    if (LEAD_PHONE_REGEX.test(withoutCountryPrefix)) {
        return withoutCountryPrefix;
    }
    if (LOCAL_PHONE_REGEX.test(withoutCountryPrefix)) {
        return `93${withoutCountryPrefix.slice(1)}`;
    }
    const cleaned = cleanLeadPhoneNumber(input);
    if (LEAD_PHONE_REGEX.test(cleaned)) {
        return cleaned;
    }
    if (LOCAL_PHONE_WITHOUT_ZERO_REGEX.test(cleaned)) {
        return `93${cleaned}`;
    }
    return cleaned;
}
export function validateLeadPhoneNumber(raw) {
    const trimmed = toLeadPhoneInput(raw);
    if (!trimmed) {
        return { valid: false, cleaned: '', error: 'Phone number is required' };
    }
    const cleaned = normalizeLeadPhoneNumber(trimmed);
    if (!LEAD_PHONE_REGEX.test(cleaned)) {
        return {
            valid: false,
            cleaned,
            error: 'Enter a valid phone number (e.g. 937XXXXXXXX or 079XXXXXXX)',
        };
    }
    return { valid: true, cleaned };
}
